/**
 * These types are found from the app.metadataTypeManager object
 */
export enum ObsidianPropertyType {
  TEXT = 'text',
  NUMBER = 'number',
  TAGS = 'tags',
  MULTITEXT = 'multitext',
  CHECKBOX = 'checkbox',
  ALIASES = 'aliases',
  DATETIME = 'datetime',
  DATE = 'date',
}
